import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { HelperService } from '../../../../services/helper/helper.service';
import { ControlBaseComponent } from '../control/control.component';

@Component({
  selector: 'app-control-checkbox-input',
  styleUrls: ['./control-checkbox-input.component.scss'],
  templateUrl: './control-checkbox-input.component.html',
})
export class ControlCheckBoxInputComponent extends ControlBaseComponent{

  @Input()  isDisabled: boolean;
  @Input()  isRequired: boolean;
  @Input()  placeholder: string;
  @Input()  model: any;
  @Input()  label: string;
  @Input()  bindValue: string;
  @Input()  cssClass: string;
  @Input()  controlName: any;
  @Output() ngModelChange = new EventEmitter();


  constructor(public helperService: HelperService,
              private changeDetection: ChangeDetectorRef) {
    super(helperService);
  }


  ModelChange() {
    if (this.ngModelChange) {
      this.ngModelChange.emit();
    }
  }
}
